import type { AttachmentDto } from '../generated/model';

export const createAttachment = (
  overrides: Partial<AttachmentDto> = {},
): AttachmentDto => ({
  bytes: 1000000,
  fileName: 'file.txt',
  id: '123',
  mimeType: 'application/pdf',
  ...overrides,
});
